import { actions, store, history, type Tsg, ReadonlyTsgInstances } from '@sparky/framework'
import { TSG_NONE, VIEW_MANAGE_TENANT } from '../../common/constants/GlobalConstants'

export const RUNNING = 'running'

export const showActivate = (app_id: string) => {
  actions.openCommonModule(`${VIEW_MANAGE_TENANT}/instances/${app_id}`, store.stateRef.current.auth?.tsg_id)
}

export const showUnifiedActivation = (path: string) => {
  history.push(path)
}

export const showRenameInstance = (tenant_id: string) => {
  actions.openCommonModule(`${VIEW_MANAGE_TENANT}/rename/${tenant_id}`, store.stateRef.current.auth?.tsg_id)
}

export const isRunningStatus = ({ status }: { status?: string }): boolean => (
  status === RUNNING
)

export const isInProgressStatus = ({ status, provisioning_status }: { status?: string, provisioning_status?: string }): boolean => Boolean(
  (status && ['pending', 'provisioning', 'error'].includes(status)) ||
  (provisioning_status && ['provisioning', 'initializing', 'error'].includes(provisioning_status))
)

export const isNonemptyArray = (arr: Array<any> | any): arr is NonNullable<Array<any>> => Array.isArray(arr) && arr.length > 0

export const hasParentOrSubTenants = (tsg: Tsg | undefined): tsg is Tsg => {
  return Boolean(tsg && (isNonemptyArray(tsg.children) ||
    (tsg.parent_id && tsg.parent_id !== TSG_NONE.id)))
}

export const showMspPortalInTsg = (tsg: Tsg | undefined, instances: ReadonlyTsgInstances | undefined) => {
  if (!store.stateRef.current.auth?.tsgs?.hasMsp || !tsg) { // hide if only has 1 tsg
    return false
  }
  if (isNonemptyArray(tsg.children) || // is parent tsg show
    isNonemptyArray(instances)) { // tsg with instances show
    return true
  }
  return false // in empty leaf tsg hide
}
